import React, { useEffect, useState } from "react";
import { auth } from "../../firebase/config";
import { toast } from "react-toastify";
import classes from "./accountDelete.module.css";
import LoadingButton from "../../components/LoadingButton";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { useUserSelector } from "../../redux/selector";
import { deleteAccount } from "../../redux/slices/authSlice";
import { unwrapResult } from "@reduxjs/toolkit";
import useRedirect from "../../hooks/useRedirect";

function AccountDelete() {
  const [fetching, setFetching] = useState(false);
  const [confirmEmail, setConfirmEmail] = useState("");
  const user = useUserSelector();
  const dispatch = useDispatch<AppDispatch>();
  const redirect = useRedirect();

  useEffect(() => {
    document.title = "Grade Tool | Xoá tài khoản";
  }, []);

  const handleDelete = () => {
    if (!user || !auth.currentUser) {
      toast.info("Vui lòng đăng nhập để sử dụng chức năng này");
      return;
    }
    if (user?.email !== confirmEmail) {
      toast.error("Địa chỉ email xác nhận không đúng");
      return;
    }
    const res = window.confirm("Bạn có chắc chắn muốn xoá tài khoản chứ?");
    if (res) {
      setFetching(true);
      dispatch(deleteAccount())
        .then(unwrapResult)
        .then(() => {
          redirect("/", "Xoá tài khoản thành công");
        })
        .catch((err) => {
          console.error(err);
          toast.error("Có lỗi xảy ra khi xoá tài khoản");
        })
        .finally(() => setFetching(false));
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.parent}>
        <div className={classes.topContainer}>
          <div className={classes.container}>
            <h2 className={classes.header}>Xoá tài khoản</h2>
            <div className={classes.formContainer}>
              <div>
                <input
                  value={confirmEmail}
                  onChange={(e) => setConfirmEmail(e.target.value)}
                  placeholder={"Xác nhân email"}
                />
              </div>
              <p className={classes.confirm}>
                Khi xác nhận xoá tài khoản, toàn bộ thông tin và hồ sơ điểm sẽ
                được xoá khỏi hệ thống.
              </p>
              <LoadingButton fetching={fetching} onClick={handleDelete}>
                Xác nhận xoá
              </LoadingButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountDelete;
